import type { MCPUserRole } from "../../services/agent-tools-service";
import type {
  AccessLevel,
  AuthHeader,
  ConnectorFormValues,
  Permission,
  ToolAccessLevel,
  TransportProtocol,
} from "./types";

export const TOOL_ACCESS_LEVELS: { value: ToolAccessLevel; label: string }[] = [
  { value: "inherit", label: "Inherit" },
  { value: "project", label: "Project" },
  { value: "user", label: "Users" },
];

export const USER_ROLE_OPTIONS: { value: MCPUserRole; label: string }[] = [
  { value: "owner", label: "Full Access" },
  { value: "editor", label: "Editor" },
  { value: "viewer", label: "Viewer" },
];

export const USER_ROLE_LABEL: Record<MCPUserRole, string> = {
  owner: "Full Access",
  editor: "Editor",
  viewer: "Viewer",
};

export const PERMISSION_OPTIONS: Permission[] = ["allow", "ask", "deny"];

export const PERMISSION_LABEL: Record<Permission, string> = {
  allow: "Always Allow",
  ask: "Needs approval",
  deny: "Never",
};

export const PERMISSION_TOOLTIP: Record<Permission, string> = {
  allow: "Always allow",
  ask: "Needs approval",
  deny: "Never allow",
};

export const ACCESS_LEVELS: { value: AccessLevel; label: string }[] = [
  { value: "organization", label: "Organization" },
  { value: "project", label: "Project" },
  { value: "user", label: "Users" },
];

export const TRANSPORT_PROTOCOLS: { value: TransportProtocol; label: string }[] = [
  { value: "http", label: "HTTP" },
];

export const AUTH_HEADERS: { value: AuthHeader; label: string }[] = [
  { value: "none", label: "None" },
  { value: "oauth", label: "OAuth 2.0" },
  { value: "api_key", label: "API Key" },
  { value: "bearer", label: "Bearer" },
];

export const DEFAULT_CONNECTOR_FORM: ConnectorFormValues = {
  alias: "",
  serverUrl: "",
  transport: "",
  accessLevel: "organization",
  projectId: "",
  users: [],
  authHeader: "oauth",
  oauthClientId: "",
  oauthClientSecret: "",
  apiKey: "",
  bearerToken: "",
};
